// extracted by mini-css-extract-plugin
export default {"card":"app-view-card_card__NcWLP","card__label":"app-view-card_card__label__t4i9P"};